import CloseButton from "./CloseButton";
import { getTranslatedString } from "./functions/functions";

function PreorderPopup({ data, lang }) {
	const { popup, onConfirm, onCancel } = data;

	return (
		<div className="promo-popup preorder-popup">
			<div className="content">
				<CloseButton onClick={onCancel} />
				{popup.img && (
					<div className="img">
						<img src={popup.img} alt={getTranslatedString(popup, "title", lang)} />
					</div>
				)}
				<div className="title">{getTranslatedString(popup, "title", lang)}</div>
				<div dangerouslySetInnerHTML={{ __html: getTranslatedString(popup, "text", lang) }} />
				<button onClick={onConfirm}>{getTranslatedString(popup, "button_label", lang)}</button>
			</div>
		</div>
	);
}

export default PreorderPopup;
